import { UseFormSetError } from 'react-hook-form';

type ErrorHandlerConfig = {
  error?: string;
  setError: UseFormSetError<any>;
  fieldMapping: Record<string, { field: string; message: string }>;
  customHandlers?: Record<string, () => void>;
};

export const handleApiErrors = (config: ErrorHandlerConfig) => {
  const { error, setError, fieldMapping, customHandlers } = config;

  if (!error) return;

  // Обработка замапленных ошибок
  if (fieldMapping[error]) {
    const { field, message } = fieldMapping[error];
    setError(field, { type: 'value', message });
  }

  // Обработка кастомных ошибок
  if (customHandlers?.[error]) {
    customHandlers[error]();
  }
};
